<template>
<section class="dflexc-jcs encounter-card">
  <div class="dflexc-jcs card-header"
       :class="{
    'title-nodata': isAdventurers || isRefChoice
    }">
    <span class="enc-race">
      {{enc.RACE}}
    </span>
    <span class="enc-name">
      {{enc.NAME}}
    </span>
    <div class="dflexc-jcc numof"
         v-if="!isAdventurers">
      <div class="lbl-numof"># of</div>
      {{enc.NUM}}
    </div>
    <div class="dflexc-jcc money-total" >
      <div class="lbl-money-total">
        Money
      </div>
      {{enc.MONEY}}
    </div>
  </div>
  <div class="dflexr-jcsb enc-data-row">
    <div class="dflexc-jcs enc-data-col1"
         v-if="shouldDisplay" >

      <StatPil v-for="stat in stats1"
               :key="stat" :val="enc[stat]"
               :name="stat"
        />
    </div>
    <div class="dflexc-jcs enc-data-col1"
         v-if="shouldDisplay">
      <StatPil v-for="stat in stats2"
               :key="stat" :val="enc[stat]"
               :name="stat"
      />
    </div>
  </div>



</section>
<div v-if="hasJewels" class="dflexc-jcs jewel-card">

</div>

</template>

<style scoped lang="scss">
@import "@/assets/styles/encounter";
</style>

<script setup>
import StatPil from "../encounter/stat-pil.vue"
import {computed, onMounted} from "vue"

const props = defineProps(['enc'])
const stats1 = [
    "AL", "LP", "AF", "DF", "AR", "ATTACKS", "KP"
]
const stats2 = [
  "MPH", "MPH", "SPECIAL", "JEWELS", "STR", "INT", "DEX"
]

const isAdventurers = computed(() => {
  return props.enc.NAME === 'Adventurers'
})

const isRefChoice = computed( () => {
  return props.enc.NAME === 'Refs Choice'
})

const shouldDisplay = computed(() => {
  const adv = isAdventurers
  const ref = isRefChoice
  let q = true
  console.log('shouldDisplay')
  if(adv.value) q = false
  if(ref.value) q = false
  console.log('q = ', q)
  return q
})

const hasSpecial = () => {
  return props.enc['SPECIAL'] !== null
}

const hasJewels = () => {
  return props.enc['JEWELS'] !== null
}

onMounted(() => {
  console.log('encounter card mounted')
  console.log('enc = ', props.enc)
})

</script>
